import { useState, useEffect } from "react";

import * as API from "../utils/api";
import { API_LOG_MESSAGES } from "../constants/api_log_messages";

function useApiRequest({ request, params, options }) {
  const abortController = new AbortController();

  const [data, setData] = useState(undefined);
  const [statusCode, setStatusCode] = useState(undefined);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setData(undefined);
    setStatusCode(undefined);

    API.runAPIRequest({ request, params, options }).then(({ data, statusCode }) => {
      console.log(API_LOG_MESSAGES[request][statusCode]);
      setData(data);
      setStatusCode(statusCode);
      setLoading(false);
    });

    return () => {
      abortController.abort();
    };
  }, [request]);

  return { data, loading, statusCode };
}

export default useApiRequest;
